<mat-icon class="{{matClass}}" [svgIcon]="name" [ngStyle]="matStyles ? matStyles : null"></mat-icon>
